export const BASE_GIFT_CARD_PATH = '/gift_cards';

export const INDEX_GIFT_CARDS_PATH = `${ BASE_GIFT_CARD_PATH }`;
export const NEW_GIFT_CARD_PATH = `${ BASE_GIFT_CARD_PATH }/new`;
export const SHOW_GIFT_CARD_PATH = `${ BASE_GIFT_CARD_PATH }/show/:id`;
